import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import store from './redux/store';
import { Provider } from 'react-redux';
import 'leaflet/dist/leaflet.css';

// import generic components
import ToastContainer from './generic_components/Toast/Toast';
import ThemeProvider from './theme/ThemeProvider';

const rootElement = document.getElementById('root');

// Check if the root element exists before attempting to render
if (rootElement) {
  // Instead of ReactDOM.render, use createRoot
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider>
          <ToastContainer 
            stacked = {true}
          >
            <App />
          </ToastContainer>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
}